var _desc, _defs, _path, _path2, _ellipse, _path3, _path4, _use, _use2, _use3, _use4, _use5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottleCustomised(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "106px",
    viewBox: "0 0 43 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "b2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-147.295861%",
    x2: "50%",
    y2: "233.437963%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.13415812,14.8600335 L8.16255671,14.7310626 C9.64087968,14.5700727 10.3155877,13.5075392 10.3155877,11.8656208 C10.3155877,10.6420973 9.80138842,9.99813757 8.90153966,9.99813757 C7.90545707,9.99813757 6.90919593,10.8996812 6.90919593,12.8315603 C6.90919593,13.4755201 7.0056083,14.1838758 7.13415812,14.8600335 M8.48393127,26 C3.69562889,26 1.13686838e-13,22.7159843 1.13686838e-13,17.6288814 C1.13686838e-13,12.4451845 3.88845362,9 9.60856369,9 C14.3970446,9 17,11.318255 17,14.4090828 C17,14.6990435 17,15.0208445 16.9355465,15.2462304 C16.9035876,15.3750224 16.7750378,15.4717952 16.5822131,15.4717952 C14.0433541,15.6004083 10.3800412,15.6648042 7.32698286,15.5682103 C7.8090447,17.1781096 8.67675601,18.7236129 9.57660477,19.6251565 C10.7978281,20.84868 11.6653609,21.1703021 12.8221307,21.1703021 C14.1397664,21.1703021 15.0717526,20.6232941 15.939464,19.8503635 C16.2287011,19.5929585 17.0321375,20.2045414 16.9035876,20.5265212 C15.5859519,23.8105369 11.954598,26 8.48393127,26",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.9%",
    y: "-5.9%",
    width: "111.8%",
    height: "111.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.492697011 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.28127,25 C28.5624966,25 26.5313541,24.7866576 23.3126729,24.7866576 C21.0313487,24.7866576 18.9689552,25 18.2501818,25 C18.0626757,25 18,24.9392144 18,24.3601422 C18,23.7810701 18.0626757,23.7201151 18.2501818,23.6896377 L19.3125427,23.4762953 C19.6252265,23.4153403 19.6875549,23.3848629 19.6875549,23.080088 L19.6875549,15.0343718 C19.6875549,14.7297663 19.6252265,14.6991195 19.3125427,14.6381646 L18.2501818,14.4552997 C18.0626757,14.4248222 18,14.3640366 18,13.8762276 C18,13.4192347 18.0626757,13.3582797 18.2501818,13.2971554 C20.8127652,12.3218761 23.2501709,10.8288182 25.7500787,9.09160176 C25.8438317,9.0306468 25.9063338,9 26.0000868,9 C26.2188439,9 26.8126133,9.24381984 26.8126133,9.45733153 C26.8126133,9.9448019 26.6876092,12.4134778 26.6876092,14.3943447 C27.6251397,11.4381984 29.3750231,9.18286488 31.2813351,9.18286488 C33.1562225,9.18286488 34,10.5543515 34,12.2306129 C34,15.1259736 32.281194,16.5582459 30.8125699,16.5582459 C30.2500515,16.5582459 29.7812863,16.3752116 29.0937639,15.9182188 C28.3439131,15.4001016 27.7188928,15.1259736 27.3124559,15.1259736 C27.1563744,15.1259736 26.9688683,15.1562817 26.9061927,15.2172367 L26.9061927,23.080088 C26.9061927,23.3848629 26.9688683,23.4458178 27.2812049,23.4762953 L29.28127,23.6896377 C29.4687761,23.7201151 29.5312781,23.8113783 29.5312781,24.3601422 C29.5312781,24.9087369 29.4687761,25 29.28127,25",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.2%",
    y: "-6.2%",
    width: "112.5%",
    height: "112.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.492697011 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.2064179,3.59372613 C36.2064179,1.56256511 37.7640166,-1.92734717e-13 39.9379845,-1.92734717e-13 C42.1121327,-1.92734717e-13 43.6695511,1.56256511 43.6695511,3.59372613 C43.6695511,5.62506077 42.1121327,7.18745225 39.9379845,7.18745225 C37.7640166,7.18745225 36.2064179,5.62506077 36.2064179,3.59372613 M34,24.3438963 C34,23.7811992 34.0648999,23.6876189 34.2594195,23.6563676 L35.3627186,23.4376085 C35.6872183,23.3751059 35.7521183,23.3126033 35.7521183,22.9999167 L35.7521183,14.7813451 C35.7521183,14.4690057 35.6872183,14.4375807 35.3627186,14.3750781 L34.2594195,14.1875703 C34.0648999,14.156319 34,14.09399 34,13.5937956 C34,13.125026 34.0648999,13.0626971 34.2594195,13.0000208 C36.9203173,11.9999792 39.8081846,10.4063364 42.4041824,8.68768838 C42.5015324,8.62501215 42.566252,8.59376085 42.6636019,8.59376085 C42.890932,8.59376085 43.5074815,8.84377127 43.5074815,9.062704 C43.5074815,9.59380252 43.2478817,11.7188911 43.2478817,15.5626276 L43.2478817,22.9999167 C43.2478817,23.3126033 43.3127817,23.3751059 43.6372814,23.4376085 L44.7404002,23.6563676 C44.9351001,23.6876189 45,23.7811992 45,24.3438963 C45,24.9064197 44.9351001,25 44.7404002,25 C43.9940508,25 41.8849829,24.7812409 39.5161348,24.7812409 C37.1474671,24.7812409 34.9733189,25 34.2594195,25 C34.0648999,25 34,24.9064197 34,24.3438963",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-4.0%",
    width: "118.2%",
    height: "108.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.492697011 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.8993208,19.5889177 C47.4332926,19.5889177 47.5176039,19.6528868 47.6019152,19.9080542 C48.1639907,21.5028508 48.613495,22.7148962 49.0914153,23.6395239 C49.5691795,24.5646831 50.1874626,24.8515693 51.0304197,24.8515693 C52.2669859,24.8515693 52.997684,24.150036 52.997684,22.9698865 C52.997684,21.8216329 52.4637123,21.0561306 50.4683442,20.386316 C47.0398397,19.2382397 46.1967264,17.4520675 46.1967264,14.7091946 C46.1967264,11.5516745 48.6979625,9 53.2785657,9 C54.2903016,9 55.3301413,9.12758373 56.3980848,9.28706339 C56.9601603,9.38257398 57.0163678,9.44672024 57.0163678,10.0844617 L57.0163678,13.8799004 C57.0163678,14.1350678 56.9601603,14.1988597 56.4261886,14.1988597 C55.8922168,14.1988597 55.8079055,14.1350678 55.7235942,13.8799004 C55.3301413,12.731824 55.1334149,12.15752 54.8523771,11.3601217 C54.5714955,10.5946194 54.0935752,10.1482535 53.1663067,10.1482535 C52.2107783,10.1482535 51.4800801,10.5946194 51.4800801,11.7747689 C51.4800801,12.8273346 51.9297406,13.3695654 53.8125374,14.1350678 C56.9881079,15.4109051 58,17.2925878 58,19.7166787 C58,23.4481483 55.4144526,26 50.9180046,26 C49.2598819,26 48.0796794,25.7767285 46.6182831,25.2662164 C46.0563637,25.0748408 46,25.0112261 46,24.3733075 C46,23.193158 46.140675,21.3750899 46.2810378,19.9080542 C46.3092977,19.6528868 46.393609,19.5889177 46.8993208,19.5889177",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.3%",
    y: "-5.9%",
    width: "116.7%",
    height: "111.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.492697011 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62,22 C62,19.7280768 63.7405318,18 66,18 C68.2594682,18 70,19.7280768 70,22 C70,24.272101 68.2594682,26 66,26 C63.7405318,26 62,24.272101 62,22",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.5%",
    y: "-12.5%",
    width: "125.0%",
    height: "125.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.492697011 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05_proc_supplier",
    transform: "translate(-751.000000, -433.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(460.000000, 395.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(70.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b2",
    transform: "translate(221.000000, 1.794255)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4518382,9.9684397 C34.5323549,14.9267382 35.8947967,20.9686137 38.5391635,28.094066 C41.4298914,35.8833574 42.6026667,59.1012518 42.0574894,97.7477491 C42.0357451,99.2891562 41.3042022,100.734357 40.0748734,101.664496 C36.5394234,104.339526 30.362265,105.67704 21.5433981,105.67704 C12.9102786,105.67704 6.95202828,104.477767 3.668647,102.07922 C2.45937957,101.195836 1.70974259,99.8169322 1.62589645,98.3217185 C-0.399882547,62.1978294 0.285135302,39.2320006 3.68095,29.4242323 C6.7126414,20.6681223 8.57870273,14.1828581 9.27913397,9.9684397 L7.38904991,9.9684397 L7.38904991,5.67704003 L36.7988197,5.67704003 L36.7988197,9.9684397 L34.4518382,9.9684397 Z",
    id: "Combined-Shape",
    fillOpacity: 0.5,
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.615568,14.67704 C10.6099634,18.7795335 8.85417941,25.1308198 5.34821618,33.730899 C1.84225295,42.3309783 1.25274569,63.6273148 3.5796944,97.6199085 C5.7940406,100.99133 11.7706354,102.67704 21.5094787,102.67704 C31.2483221,102.67704 37.4264295,100.875379 40.043801,97.2720554 C40.5981518,61.2701493 39.5457514,39.6888613 36.8865998,32.5281914 C34.2274483,25.3675216 33.001049,19.7504711 33.207402,15.67704 L10.615568,14.67704 Z",
    id: "Combined-Shape",
    fill: "#FFA207"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    fill: "#FFC86D",
    cx: 22.1872449,
    cy: 15.17704,
    rx: 11,
    ry: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18724488,0.677040033 L35.1872449,0.677040033 C36.8440991,0.677040033 38.1872449,2.02018578 38.1872449,3.67704003 L38.1872449,7.67704003 L5.18724488,7.67704003 L5.18724488,3.67704003 C5.18724488,2.02018578 6.53039063,0.677040033 8.18724488,0.677040033 Z",
    id: "Rectangle-8",
    fill: "#3A3A40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4775391,1.12468999 C17.9729818,1.12468999 22.0159505,1.12468999 23.6064453,1.12468999 C21.0751953,10.0319165 20.7705078,12.0906009 18.7491481,21.4948559 C17.926555,25.321921 15.5264534,36.8180772 14.6264731,52.8096145 C14.1096136,61.9935698 14.5248615,79.5572538 15.872217,105.500667 C13.5494838,105.500667 9.85835422,104.537776 4.79882813,102.611995 C2.86697387,89.9078931 2.86697387,80.6637525 2.86697387,54.9895484 C2.86697387,37.3575904 8.73738578,25.200365 11.2376995,12.0906009 C11.7148604,9.58872827 11.7948069,5.93342464 11.4775391,1.12468999 Z",
    id: "Rectangle-9",
    fillOpacity: 0.253736413,
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(16.000000, 59.000000) rotate(-89.000000) translate(-16.000000, -59.000000) translate(-19.000000, 46.000000)",
    opacity: 0.698935688
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "screen"
    },
    xlinkHref: "#path-2"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "screen"
    },
    xlinkHref: "#path-4"
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-5"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "screen"
    },
    xlinkHref: "#path-6"
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-7"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "screen"
    },
    xlinkHref: "#path-8"
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-10"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    style: {
      mixBlendMode: "screen"
    },
    xlinkHref: "#path-10"
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottleCustomised);
export default __webpack_public_path__ + "static/media/bottle-customised.77d1f5c447895206e8bdfe7b93f55180.svg";
export { ForwardRef as ReactComponent };